module.exports = __webpack_public_path__ + "static/step-4-8f605f4273f97a097d10fd42f55a9a39.png";